module.exports = __webpack_public_path__ + "img/us-ms.314a66ee.svg";